import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LocalStoreService } from "../../shared/services/local-store.service";

@Injectable()
export class ReportsService {
  private baseUrl: string = '';
  private collection: string = 'reports';
  public owner: string;
  public account: string;
  public email: string;
  public ownerName: string;

  items: any[];

  constructor(private http: HttpClient, public local: LocalStoreService) {
    this.baseUrl=this.local.getItem('url.base')+'/'+this.collection; 
    this.owner    = this.local.getItem('user.id');  
    this.account  = this.local.getItem('user.account');
    this.email = this.local.getItem('user.email');
    this.ownerName   = this.local.getItem('user.fullname');  
    let itemSub: Subscription;
  }



  // get by id
  findById(id): Observable<any> {
    return this.http.get(this.baseUrl+'/id/'+id);
  }

  // get by owner
  findByOwner(): Observable<any> {
    return this.http.get(this.baseUrl+'/owner/'+this.owner);
  }

  // get by account
  findByAccount(): Observable<any> {
    return this.http.get(this.baseUrl+'/account/'+this.account);
  }
 
  // get by account
  findByParent(id): Observable<any> {
    return this.http.get(this.baseUrl+'/parent/'+id);
  }

  // add 
  create(item){
    item.recordId = Math.round(Math.random() * 10000000000).toString();
    item.pubDate = new Date();
    item.owner = this.owner;
    item.account = this.account;
    item.ownerName = this.ownerName;
    return this.http.post(this.baseUrl, item);
  }

  update(item){
    return this.http.put(this.baseUrl, item); 
  }

   // delete 
   delete(id) {
    return this.http.delete(this.baseUrl+"/id/"+id); 
  } 


}
